const haematemesis = [

    { 
    label:"Frequency:",
    controlType:"radio button",
    options:["Occasonal", "Frequent","Continuous"]
    },

    { 
    label:"Containing:",
    controlType:"checkbox group",
    options:["Fresh blood", "Dark blood","Coffee grounds"],
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]



export default haematemesis